// Authentication utility functions
import Cookies from 'js-cookie';

import { store } from '../redux/store';

/**
 * Get the authentication token from local storage or cookies
 * @returns {string|null} The authentication token or null if not found
 */
export const getAuthToken = () => {
  // First check Redux store (primary for persistence with redux-persist)
  const state = store.getState();
  const reduxToken = state.user?.token;
  if (reduxToken) return reduxToken;
  
  // Then check localStorage (legacy fallback)
  const localToken = localStorage.getItem('authToken') || localStorage.getItem('jwt');
  if (localToken) return localToken;
  
  // Then check cookies (primary source for TSG)
  const cookieToken = Cookies.get('token');
  if (cookieToken) return cookieToken;
  
  return null;
};

/**
 * Check if the user is authenticated
 * @returns {boolean} True if authenticated, false otherwise
 */
export const isAuthenticated = () => {
  const token = getAuthToken();
  if (!token) return false;
  
  // Validate JWT token structure and expiration
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return false;
    
    const payload = JSON.parse(atob(parts[1]));
    
    // Check if token has expiry and if it's expired
    if (payload.exp) {
      const currentTime = Math.floor(Date.now() / 1000);
      return payload.exp > currentTime;
    }
    
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Get headers with authentication token
 * @returns {Object} Headers object with Authorization token
 */
export const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': token ? `Bearer ${token}` : '',
  };
};
